import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CallParticle from "../Particle/CallParticle";
import bgImage from "../../assets/translatebg.jpg";
import Avatar from "../Avatar";
import { useSelector } from "react-redux";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = new SpeechRecognition();
recognition.continuous = false; // Set to false to stop listening after speech ends
recognition.interimResults = true;
recognition.lang = "en-US";

function Call() {
  const navigate = useNavigate();
  const {user} = useSelector((state)=>state.auth)
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [_ , setResponseText] = useState("");
  const handleCut = () => {
    // Stop any ongoing speech synthesis
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
    setTimeout(() => {
      navigate('/app');
    }, 1000);
  };
  useEffect(() => {
    recognition.onresult = (event) => {
      let interimTranscript = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcriptPart = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          setTranscript(transcriptPart + " ");
        } else {
          interimTranscript += transcriptPart;
        }
      }
      document.getElementById("interim").innerHTML = interimTranscript;
    };

    recognition.onend = () => {
      setListening(false);
      if (transcript.trim()) {
        callGeminiAPI(transcript);
      }
    };

    recognition.onspeechend = () => {
      // Clear any existing timeout to ensure no multiple timeouts run
      recognition.stop();
      setListening(false);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);

  const startListening = () => {
    // Stop any ongoing speech synthesis
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
    // Clear the previous response text
    setResponseText("");
    // Clear the previous transcript
    setTranscript("");
    // Start speech recognition
    recognition.start();
    setListening(true);
  };

  const stopListening = () => {
    recognition.stop();
    setListening(false);
  };

const callGeminiAPI = async (text) => {
  try {
    const response = await axios({
      url: "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-goog-api-key": "AIzaSyD3yV_YREeaPTHd-krkWY-Vz6c87Gnb7EQ", // move API key to header
      },
      data: {
        contents: [{ parts: [{ text }] }],
      },
    });

    const rawResponse = response.data.candidates?.[0]?.content?.parts?.[0]?.text || "";
    const filteredResponse = filterResponse(rawResponse);
    setResponseText(filteredResponse);
    textToSpeech(filteredResponse);

  } catch (error) {
    console.error("Error calling Gemini API:", error.response?.data || error.message);
  }
};


  const filterResponse = (text) => {
    return text.replace(/##/g, '').replace(/\*\*/g, '').replace(/\*/g, '');
  };
  
  const textToSpeech = (text) => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.onend = () => {
      // Restart the microphone
      startListening()
    };
    synth.speak(utterance);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'P') {
        e.preventDefault(); // Prevent the default print dialog
        navigate("/app");
      }

    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);
  return (
    <>
      <div className="relative min-h-screen text-white flex flex-col" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover' }}  >
      <CallParticle />
      <div className="absolute  inset-0 bg-black bg-opacity-50"></div>
        <header className=" relative flex justify-between items-center px-4 py-4 z-10">
          <div className="flex space-x-4">
            <button
              on
              onClick={() => {
                navigate("/app");
              }}
            >
              <img
                src="https://img.icons8.com/?size=100&id=EiJnl8UJCjVI&format=png&color=999999"
                alt="Home"
                className="h-8 w-8"
              />
            </button>
          </div>
          <h1 className="self-center whitespace-nowrap text-3xl font-bold text-white cursor-pointer" onClick={() => navigate("/app")}>GemX</h1>
          <Avatar
                  width={40}
                  height={40}
                  name={user?.firstName}
                  imageUrl={user?.profile_pic}
                  userId=""
                  rounded
                />
        </header>
       
        <main className="relative flex flex-1 z-10">
          <section className="flex flex-col items-center justify-center flex-1 p-4">
            <div className="dark:bg-gray-800 bg-slate-200 rounded-3xl p-6 w-full max-w-md relative">
              <h2 className="text-2xl mb-4 text-white text-center">
                I can hear you!
              </h2>

              <div className="flex flex-col items-center justify-center flex-grow space-y-2 md:space-y-4 lg:space-y-6">
                <img
                  src="/robot chatbot.png"
                  alt="Robot Call"
                  className="mb-4 mx-auto h-36 w-50"
                />

                <p
                  className="outline-none h-20 md:h-28 lg:h-36 w-full p-2 md:p-4 text-white rounded dark:bg-gray-800 bg-slate-200 overflow-hidden mb-6 md:mb-4 lg:mb-6"
                  id="interim"
                >
                  {transcript}
                </p>

                <div className="flex justify-center space-x-4 mb-6 md:mb-4 lg:mb-6">
                  <div className={listening ? 'mic-container listening' : 'mic-container'}>
                    <button
                      className="text-white p-2 md:p-3 lg:p-4 rounded-full"
                      onClick={listening ? stopListening : startListening}
                    >
                      <img
                        src="https://img.icons8.com/?size=100&id=9622&format=png&color=999999"
                        alt="Microphone"
                        className="h-8 w-8"
                      />
                    </button>
                    {listening && <div className="wave-container"></div>}
                  </div>
                  <button
                    onClick={handleCut}
                    className="bg-red-500 text-white rounded-full p-2 md:p-3 lg:p-4"
                  >
                    <img
                      src="https://img.icons8.com/?size=100&id=3879&format=png&color=FFFFFF"
                      alt="End Call"
                      className="h-7 w-7"
                    />
                  </button>
                </div>
                <div className="mt-4 flex justify-center items-center space-x-2" onClick={()=>navigate('/videoCall')}>
                  <button className="text-white p-2 rounded-full">
                    <img
                      src="https://img.icons8.com/?size=100&id=60021&format=png&color=999999"
                      alt="Enable Video"
                      className="h-6 w-6"
                    />
                  </button>
                  <label htmlFor="enable-video" className="text-white">
                    Enable video
                  </label>
                </div>
                <div className="absolute bottom-4 right-4 flex space-x-4">
                  <button onClick={()=>navigate('/callSetting')}>
                    <img
                      src="https://img.icons8.com/?size=100&id=364&format=png&color=999999"
                      alt="Settings"
                      className="h-6 w-6"
                    />
                  </button>
                  <button onClick={()=>navigate('/help')}>
                    <img
                      src="https://img.icons8.com/?size=100&id=646&format=png&color=999999"
                      alt="Help"
                      className="h-6 w-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
  
}

export default Call;
